import type { RentalDuration } from '../../data/dumpsters'

export type PaymentMethod = 'card-now' | 'card-on-file'

export interface ReservationState {
  sizeId: string | null
  rentalDuration: RentalDuration
  deliveryDate: Date | undefined
  address: {
    street: string
    city: string
    state: string
    zip: string
    notes: string
  }
  contact: {
    firstName: string
    lastName: string
    email: string
    phone: string
  }
  paymentMethod: PaymentMethod
  card: {
    name: string
    number: string
    expiry: string
    cvc: string
  }
}

export const initialReservation: ReservationState = {
  sizeId: null,
  rentalDuration: 'week',
  deliveryDate: undefined,
  address: { street: '', city: '', state: '', zip: '', notes: '' },
  contact: { firstName: '', lastName: '', email: '', phone: '' },
  paymentMethod: 'card-now',
  card: { name: '', number: '', expiry: '', cvc: '' },
}

export const STEP_LABELS = [
  'Size & rental',
  'Delivery',
  'Contact',
  'Payment',
] as const
